import {downloadFileFromUrl} from '@Utils/file-download.util';
import {ChatDocumentType} from '@Libraries/chat-document.types';

interface OpenableChatDocument {
  documentHashedId: string;
  filename: string;
  documentType: ChatDocumentType;
}

const getChatDocumentUrl = (documentHashedId: string): string => window.PMW.util.site_url(`marketingagent/document/${documentHashedId}`);

const getFilenameWithoutExtension = (document: OpenableChatDocument): string => {
  const extensionSuffix = `.${document.documentType}`;
  return document.filename.toLowerCase().endsWith(extensionSuffix) ? document.filename.slice(0, -extensionSuffix.length) : document.filename;
};

export const openChatDocument = (document: OpenableChatDocument, openPdf: (url: string, title?: string) => void): void => {
  const url = getChatDocumentUrl(document.documentHashedId);
  if (document.documentType === ChatDocumentType.PDF) {
    openPdf(url, document.filename);
    return;
  }
  void downloadFileFromUrl(url, getFilenameWithoutExtension(document), document.documentType);
};
